module.exports = __webpack_public_path__ + "static/img/200065.38d93119.png";